import React, { useState } from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../utils/styles';
import LoyaltyPurchaseOption from './loyalty/LoyaltyPurchaseOption';

const LevelsContainer = styled.div`
    margin-bottom: 2em;

    @media screen and (min-width: ${breakpoints.desktop}px) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 2rem;
    }
`;

const Back = styled.button`
    background: none;
    border: 0;
    color: var(--text-primary);
    cursor: pointer;
    margin: 0;
    outline: none;
    padding: 0;

    &:focus { border: 0; outline: none; }
`;

interface Props {
    altStyles?: boolean;
    levels: any[];
    selected?: any;
    onLevelSelect: (option: any) => void;
}

function IeSignUpOptions(props: Props) {
    const [parent, setParent] = useState(null);
    let levels;

    function onSelect(option) {
        if (option.group) {
            setParent(option.id);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        props.onLevelSelect(option);
    }

    if (parent) {
        levels = props.levels.filter(level => level.parent === parent);
    } else {
        levels = props.levels.filter(level => !level.parent);
    }

    return <div>
        <LevelsContainer>
            {levels.map(option => <LoyaltyPurchaseOption
                key={option.id}
                option={option}
                selected={props.selected && props.selected.id === option.id}
                onSelect={onSelect}
                altStyles={props.altStyles}
            />)}
        </LevelsContainer>
        {parent && <Back onClick={e => setParent(null)}><i className='fal fa-arrow-left'></i> Volver</Back>}
    </div>;
}

export default IeSignUpOptions;